/* <footer-accordion> — mobilde link grupları akordiyon, ≥750px her zaman açık */
class FooterAccordion extends HTMLElement {
  connectedCallback() {
    this.mql = window.matchMedia('(min-width: 750px)');
    this.groups = Array.from(this.querySelectorAll('details.footer__group'));
    this.onChange = () => this.sync();
    this.mql.addEventListener('change', this.onChange);
    /* Masaüstünde başlığa tıklama grubu kapatmasın */
    this.groups.forEach((d) =>
      d.querySelector('summary')?.addEventListener('click', (e) => this.mql.matches && e.preventDefault())
    );
    this.sync();
  }
  disconnectedCallback() {
    this.mql?.removeEventListener('change', this.onChange);
  }
  sync() {
    const desktop = this.mql.matches;
    this.groups.forEach((d) => {
      d.open = desktop;
      const summary = d.querySelector('summary');
      if (!summary) return;
      if (desktop) {
        summary.setAttribute('tabindex', '-1');
        summary.setAttribute('role', 'heading');
        summary.setAttribute('aria-level', '2');
      } else {
        summary.removeAttribute('tabindex');
        summary.removeAttribute('role');
        summary.removeAttribute('aria-level');
      }
    });
  }
}
if (!customElements.get('footer-accordion')) customElements.define('footer-accordion', FooterAccordion);
